import { render, staticRenderFns } from "./MSetTable.vue?vue&type=template&id=20a3a17e&scoped=true"
import script from "./MSetTable.vue?vue&type=script&lang=js"
export * from "./MSetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3a17e",
  null
  
)

export default component.exports